import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"

class Explications extends React.Component {
  render () {
    return (
      <React.Fragment>
      <h2 className="center">Quelques explications</h2>
      <div className="container">
      <p>Vous allez devoir répondre à de nombreuses de questions ,.....</p>
      <p>Vous pouvez arreter a tout moment et recommencer !</p>
      <div className="row">

        <p className="col s4 offset-s8"><Link className="btn btn-large wave" to="/Elementsdebases">Suivant</Link></p>
      </div>
      </div>
      </React.Fragment>
    );
  }
}

export default Explications
